/**
 * Court layer: Riverside County Superior Court. See src/courts/index.js for the shape.
 * data/ has no Riverside material of its own; the statewide fee schedule's appendix gives
 * its first paper fees, which include a local courthouse construction surcharge.
 */
export default {
  id: "riverside-superior",
  details: {
    fees: {
      firstPaper: {
        value: { unlimited: 450, limitedOver10k: 395, limitedUpTo10k: 255, udLimitedOver10k: 410, udLimitedUpTo10k: 270 },
        text: "Riverside adds a $50 courthouse construction surcharge to every first paper, so its first paper fees are higher than the statewide amounts.",
        cite: "Statewide Civil Fee Schedule, Appendix; GC 70622",
      },
    },
  },
};
